<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Proveedores</h1>
      <p class="mb-3 text-color-secondary">
        Gestiona y consulta la información de nuestros proveedores, aquí podrás ver datos como el nombre completo, RFC, sector, fecha de creación y estatus, utiliza los filtros para acceder rápidamente a los detalles necesarios.
      </p>
    </div>
    <p-toast></p-toast>
  </div>
  <div class="row">
    <div class="col-12">
      <app-main-table
        [apiService]="apiProviderService"
        [columns]="columns"
        [pluralEntityName]="'proveedores'"
        [additionalMainActions]="additionalMainActions"
        (onMainAction)="mainActions($event)"
        [actions]="actions"
        (onAction)="actionMethods($event)"
      ></app-main-table>
    </div>
  </div>
</p-card>

<p-dialog [(visible)]="createEntity" [style]="{ width: '750px' }" [header]="action === 'CREATE' ? 'Nuevo proveedor' : 'Actualizar proveedor'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-provider-form></app-provider-form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" (click)="saveForm()" [disabled]="!providerService.entity.valid"></button>
  </ng-template>
</p-dialog>